/**
 * Created with IntelliJ IDEA.
 */
define(function (require) {
    "use strict";

    var Backbone = require("backbone");
    var $ = require("jquery");

    var RevisionUtility = require("utils/RevisionUtility");

    var BaseModel = require("models/BaseModel");
    var RevisionedModel = require("models/RevisionedModel");

    var BaseCollection = require("collections/BaseCollection");

    var CONST = require("const");

    var METHODS = {
        GET: "GET",
        POST: "POST"
    };

    var DEFAULT_FETCH_METHOD = METHODS.GET;

    var FetcherItemModel = BaseModel.extend({
        name: "FetcherItemModel",
        defaults:{
            name: "",
            method: DEFAULT_FETCH_METHOD,
            url: "",
            headers: {},
            doNotMergeHeaders: "",
            body: "",
            timeout: "",
            model: null, //local, not send to the batchelor
            fetchOptions: {}, //local, not send to the batchelor
            successCallback: function(){}, //local, not send to the batchelor
            errorCallback: function(){} //local, not send to the batchelor
        },

        initialize: function(options){
            this.set("url", options.model.url());
            this.isFresh = false;

            if(options && options.model && _.isFunction(options.model.getFetchMethod)){
                this.set("method", options.model.getFetchMethod());
            }

            if(options && options.model && _.isFunction(options.model.getFetchHeaders)){
                var headers = _.extend(options.model.getFetchHeaders(), options.headers); //extend the model headers (will override same properties if provided)
                this.set("headers", headers);
            }

            if(options && options.model && _.isFunction(options.model.getFetchFreshnessTime)){
                //use freshnessTime from options if provided and if not, take value from model
                var freshnessTime = _.has(this.get("fetchOptions"), "freshnessTime") ? this.get("fetchOptions").freshnessTime : options.model.getFetchFreshnessTime();
                var fetchOptions = _.extend(this.get("fetchOptions"), {freshnessTime: freshnessTime});
                this.set("fetchOptions", fetchOptions);
            }

            if (this.get("method") === METHODS.GET && _.has(this.get("fetchOptions"), "data")) {
                var dataParams = $.param( this.get("fetchOptions").data, this.get("fetchOptions").traditional ); // taken from jquery
                var originalUrl = this.get("url");
                var url = originalUrl + ( /\?/.test( originalUrl ) ? "&" : "?" ) + dataParams;
                this.set("url", url);
            }
        },

        toJSON : function () {
            if(!this.isFresh){
                var apiModel = new Backbone.Model(_.omit(this.attributes, "model", "fetchOptions", "successCallback", "errorCallback"));
                return BaseModel.prototype.toJSON.call(apiModel);
            }
        },

        initializeFetch: function(){
            this._setFetchState(BaseCollection.FetchState.LOADING);

            var model = this.get("model");
            var options = this.get("fetchOptions");

            if(model instanceof Backbone.Model){
                if(model instanceof RevisionedModel){
                    this._modelSimulateRevisionedFetch(options);
                }
                else{
                    this._modelSimulateBackboneFetch(options);
                }
            }
            else if(model instanceof BaseCollection){
                this._collectionSimulateBaseFetch(options);
            }
        },

        simulateFetch: function(resp, isSuccess, headers){
            if(isSuccess){
                this.get("successCallback")(resp, headers);
            }
            else{
                this.get("errorCallback")(resp);
            }
        },

        _setFetchState: function(state) {
            var model = this.get("model");
            if(_.isFunction(model.setFetchState)){
                model.setFetchState(state);
            }
        },

        _setCallbackFunctions: function(options){
            this.set("successCallback", options.success);
            this.set("errorCallback", options.error);
        },

        //*****************************************************************************************************************
        //*********************** code from backbone, base and revisoned model/collection's fetch ******************8******
        //*****************************************************************************************************************

        _modelSimulateBackboneFetch: function(options){
            options = options ? _.clone(options) : {};
            if (options.parse === void 0) {options.parse = true;}
            var model = this.get("model");
            var success = options.success;
            options.success = function(resp, headers) {

                //xhr functions used in the revisioned model parse
                options.xhr = {
                    getResponseHeader: function(headerName){
                        if(headerName === RevisionUtility.CONSTS.REVISION_HEADER) {return headers.etag;}
                        else {
                            return  headers[headerName];
                        }
                    },
                    getAllResponseHeaders: function(){

                    }
                };

                if (!model.set(model.parse(resp, options), options)) {return false;}
                if (success) {success(model, resp, options);}
                model.trigger('sync', model, resp, options);
            };
            this._backboneWrapError(this, options);

            this._setCallbackFunctions(options);
        },

        _modelSimulateRevisionedFetch: function(options){
            options = options ? _.clone(options) : {};
            var success = options.success;
            options.success = function(model, resp, options) {
                if (model.useMemento) {
                    model.store();  //on success model was updated create a memento restore point
                }
                if (success) {
                    success(model, resp, options);
                }
            };
            this._modelSimulateBackboneFetch(options);
        },

        _collectionSimulateBackboneFetch: function(options){
            options = options ? _.clone(options) : {};
            if (options.parse === void 0) {options.parse = true;}
            var success = options.success;
            var collection = this.get("model");
            options.success = function(resp, headers) {

                //xhr functions used in the revisioned model parse
                options.xhr = {
                    getResponseHeader: function(headerName){
                        if(headerName === RevisionUtility.CONSTS.REVISION_HEADER) {return headers.etag;}
                        else {
                            return  headers[headerName];
                        }
                    },
                    getAllResponseHeaders: function(){

                    }
                };

                var method = options.reset ? 'reset' : 'set';
                collection[method](resp, options);
                if (success) {success(collection, resp, options);}
                collection.trigger('sync', collection, resp, options);
            };
            this._backboneWrapError(this, options);

            this._setCallbackFunctions(options);
        },

        _collectionSimulateBaseFetch: function(options){
            options = options || {};

            var freshnessTime = _.has(options, "freshnessTime") ? options.freshnessTime : null;
            if (freshnessTime && freshnessTime > (new Date().getTime()) - this.get("model").lastFetchSuccess) {
                options.success(this.get("model"), {}, options);
                this.isFresh = true;

                return;
            }

            var successFunc = options.success;
            var errorFunc = options.error;
            options.success = function(collection, response, options) {
                collection.setFetchState(BaseCollection.FetchState.SUCCESS);
                collection.lastFetchSuccess =  new Date().getTime();
                if (_.isFunction(successFunc)) {
                    successFunc(collection, response, options);
                }
            };
            options.error = function(collection, response, options) {
                if (!options.type || CONST.HTTP_METHOD.GET === options.type) {
                    collection.setFetchState(BaseCollection.FetchState.ERROR);
                }
                if (_.isFunction(errorFunc)) {
                    errorFunc(collection, response, options);
                }
            };
            this._extendErrorBaseCollection(options);

            this._collectionSimulateBackboneFetch(options);
        },

        _backboneWrapError: function(model, options){
            var error = options.error;
            var collectionOrModel = this.get("model");
            options.error = function(resp) {
                if (error) {error(collectionOrModel, resp, options);}
                model.trigger('error', collectionOrModel, resp, options);
            };
        },

        _extendErrorBaseCollection: function (options) {
            if (_.isObject(options)) {
                var error = options.error;

                options.error = function (collection, resp, options) {
                    if (404 === resp.status && options.success) {
                        options.ignoreError = true;
                        options.success.apply(this, []);
                    } else if (error) {
                        error.apply(this, [].slice.apply(arguments));
                    }
                };
            }
        }
    });

    return FetcherItemModel;
});
